import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";
import { SLICE } from "../../common/constants/slice";
//
const selectDomain = (state) => state[SLICE.SUMMARY] || initialState;
/**
 * Getting hotel state to summary component
 */
export const selectHotel = createSelector([selectDomain], (state) => state.hotel);
/**
 * Getting currency state to summary component
 */
export const selectCurrency = createSelector([selectDomain], (state) => state.currency);
/**
 * Getting pms sync toggle state to summary component
 */
export const selectPmsSync = createSelector([selectDomain], (state) => state.pmsSync);
/**
 * Getting summary widget booking date state to summary widget component
 */
export const selectSummaryBookingDate = createSelector(
  [selectDomain],
  (state) => state.summaryBookingDate
);
/**
 * Getting summary widget stay date state to summary widget component
 */
export const selectStayDate = createSelector(
  [selectDomain],
  (state) => state.stayDate
);
/**
 * Getting summary otb state for summary widget component
 */
export const selectSummaryOtb = createSelector([selectDomain], (state) => state?.summaryOtb);
/**
 *Getting is detailed in summary tab state for summary widget component
 */
export const selectIsDetailed = createSelector([selectDomain], (state) => state?.isDetailed);
/**
 * Getting chart breakdown state to summary widget component
 */
export const selectBreakdown = createSelector([selectDomain], (state) => state.chartBreakdown);
/**
 * Getting date comparison state to summary widget component
 */
export const selectDateComparison = createSelector([selectDomain], (state) => state.dateComparison);
/**
 *  Getting summary widget alignment toggle state to summary widget component
 */
export const selectSummaryAlignmentToggle = createSelector(
  [selectDomain],
  (state) => state.summaryAlignmentToggle
);
/**
 * Getting symmetric comparison toggle state for summary widget component
 */
export const selectSymmetricComparisonToggle = createSelector(
  [selectDomain],
  (state) => state?.symmetricComparisonToggle
);
/**
 *  Getting pace horizon state to dashboard component
 */
export const selectPaceHorizon = createSelector(
  [selectDomain],
  (state) => state.summaryPaceHorizon
);
/**
 *  Getting pace variable state to dashboard component
 */
export const selectPaceVariable = createSelector(
  [selectDomain],
  (state) => state.summaryPaceVariable
);
/**
 *  Getting selected summary forecast state to dashboard component
 */
export const selectSummaryForecastFilter = createSelector(
  [selectDomain],
  (state) => state.summaryForecastFilter
);

export const selectBEFilters = createSelector(
  [selectDomain],
  (state) => state.summaryBEFilters
);
